import { LogisticApi } from './logisticApi';

const logisticApi = new LogisticApi();

export { logisticApi };
